export default __webpack_public_path__ + "static/appShapes-4bd653c422b574c8cb36088c7833ece2.png";